export const cascadingItemsRules = [
  {
    triggeringItemId: '175',
    triggeringValue: 'yes',
    triggeredItemId: '488',
    triggeredItemCategpory: '12',
  },
];
